import type { CollectedDataItem } from '../../domain/message';

import SharedDataExtractionService from './sharedDataExtractionService';

const createGmailDataExtractionService = () => {
  const { extractAttributeValueByKey, extractContentByKey, getDomainsFromEmails } = SharedDataExtractionService;

  const extractNewEmailData = (collectedData: CollectedDataItem[]) => {
    const recipientsEmails =
      extractAttributeValueByKey<string[]>(collectedData, 'Search recipient emails', 'data-hovercard-id') ?? [];
    const recipientsDomains = getDomainsFromEmails(recipientsEmails);
    const subject = extractAttributeValueByKey(collectedData, 'New Email Subject', 'value');

    return { recipientsEmails, subject, recipientsDomains };
  };

  const extractEmailData = (collectedData: CollectedDataItem[]) => {
    const senderEmails =
      extractAttributeValueByKey<string[]>(collectedData, 'Sender and recipients emails', 'email') ?? [];
    const senderDomains = getDomainsFromEmails(senderEmails);
    const subject = extractContentByKey(collectedData, 'Subject') as string;

    return { senderEmails, senderDomains, subject };
  };

  const extractReplyToEmail = (collectedData: CollectedDataItem[]) => {
    const recipientsEmails = extractAttributeValueByKey<string[]>(collectedData, 'Reply to email', 'email') ?? [];
    const recipientsDomains = getDomainsFromEmails(recipientsEmails);
    return { recipientsEmails, recipientsDomains };
  };

  return { extractNewEmailData, extractEmailData, extractReplyToEmail };
};

const GmailDataExtractionService = createGmailDataExtractionService();
export default GmailDataExtractionService;
